import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';
import { PageSEO } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/page-seo';

export const AboutUsContent = () => {
  return (
    <>
      <PageSEO pathname="/about-us" />
      <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Main Content - Image on left, intro on right */}
          <div className="grid md:grid-cols-2 gap-12 mb-12">
            {/* Left Column - Compact Image */}
            <div className="flex justify-center items-start">
              <img
                src="https://mn.redebins.com/wp-content/uploads/sites/148/2019/05/Redebins-Vinny-Ask-Me-Anything.jpg"
                alt="RED-E-BINS Team"
                className="w-full max-w-[320px] h-auto rounded-lg"
                onError={(e) => {
                  // Fallback to local image if remote fails
                  (e.target as HTMLImageElement).src = '/redebins/images/binny-mascot.png';
                }}
              />
            </div>

            {/* Right Column - Intro Content */}
            <div className="space-y-6">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-6 italic">
                  We're The Best In The Binz
                </h2>
                <p className="text-[#333333] mb-6">
                  At RED-E-BINS, we're all about making it easy to get your project done.
                </p>
                <ul className="space-y-3 text-[#333333] mb-6">
                  <li>Quick online scheduling</li>
                  <li>Available by chat, phone, or text</li>
                  <li>Straightforward, competitive pricing</li>
                  <li>Zero-hassle delivery</li>
                  <li>Flexible pickup options</li>
                </ul>
                <h3 className="text-xl font-bold text-[#333333] mb-2">
                  Need Assistance?{' '}
                  <a href="tel:9529312577" className="text-[#E31837] hover:underline">
                    952-931-2577
                  </a>
                </h3>
              </div>
            </div>
          </div>

          {/* Feature Sections - Below the image */}
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-xl font-bold text-[#333333] mb-4 italic">
                &gt;&gt; Fits Right In, From Start To Finish
              </h3>
              <p className="text-[#333333] text-sm">
                You're just a few clicks from getting a driveway-sized RED-E-BIN Dumpster delivered directly to you. A RED-E-BIN Dumpster fits in the smallest of places, so it's alley- and driveway-friendly, and also lighter than a typical roll-off dumpster. We'll always put 2x4s underneath to protect your driveway or lawn. And there's none of the hassle, space issues or giant roll-off truck—just a quick and quiet pickup truck with our custom trailer.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-xl font-bold text-[#333333] mb-4 italic">
                &gt;&gt; Right On Time - Because We're right in Town
              </h3>
              <p className="text-[#333333] text-sm">
                We're locally owned and operated, so we know exactly where you're at, and how long it'll take to get a RED-E-BIN Dumpster to you. Which is usually, pretty darn quick.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-xl font-bold text-[#333333] mb-4 italic">
                &gt;&gt; We Get It: Work Waits for No-One
              </h3>
              <p className="text-[#333333] text-sm">
                When you've got a project, there's no time to waste. Everything in the RED-E-BIN system is designed for a seamless, smooth experience, from online booking to delivery and pickup. And we'll jump on the phone with you any time, for any reason.
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gray-50 rounded-lg p-8 text-center">
            <h3 className="text-xl font-bold text-[#333333] mb-2">
              Need Assistance?
            </h3>
            <a
              href="tel:9529312577"
              className="text-2xl font-bold text-[#E31837] hover:underline block mb-4"
            >
              952-931-2577
            </a>
            <Link
              href="/#dumpster-sizes"
              className="inline-block bg-[#E31837] text-white px-6 py-3 rounded-md font-semibold hover:bg-[#C1152E] transition-colors"
            >
              Click Here to Choose Your Dumpster Size
            </Link>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

